<template>
  <div>
    <UIMenu location="top" :viewport-margin="8">
      <template #activator="{ props: activatorProps }">
        <button
          v-bind="activatorProps"
          type="button"
          class="relative isolate flex items-center rounded-md text-left before:absolute before:inset-0 before:-z-10 before:rounded-[inherit] before:bg-current before:opacity-0 before:transition-opacity before:duration-[250ms] before:ease-[cubic-bezier(0.4,0,0.2,1)] hover:before:opacity-[0.04]"
          :class="rail ? 'h-8 w-8 justify-center' : 'w-full gap-2 px-2 py-1.5'"
          data-test-id="user-avatar-toggle-button"
        >
          <UIAvatar data-test-id="user-avatar" size="sm">
            {{ initials }}
          </UIAvatar>
          <template v-if="!rail">
            <div class="min-w-0 flex-1">
              <div
                class="truncate text-sm font-medium leading-none text-grey-900"
                data-test-id="user-name"
              >
                {{ fullName }}
              </div>
              <div
                class="truncate text-xs text-grey-700"
                :title="email"
                data-test-id="user-email"
              >
                {{ email }}
              </div>
            </div>
            <v-icon size="18" class="text-grey-700">mdi-dots-vertical</v-icon>
          </template>
        </button>
      </template>
      <div class="flex min-w-[250px] max-w-72 flex-col bg-white p-1">
        <div class="flex items-center gap-3 p-2">
          <UIAvatar data-test-id="user-avatar">{{ initials }}</UIAvatar>
          <div class="min-w-0 flex-1">
            <div
              class="truncate text-sm font-semibold text-grey-900"
              data-test-id="user-name"
            >
              {{ fullName }}
            </div>
            <div
              class="truncate text-xs text-grey-600"
              :title="email"
              data-test-id="user-email"
            >
              {{ email }}
            </div>
          </div>
        </div>

        <v-divider class="my-1" />
        <div class="p-1">
          <AppLanguageSwitcher />
        </div>
        <v-divider class="my-1" />
        <UIButton
          icon="mdi-key-outline"
          class="flex w-full justify-start normal-case"
          :disabled="loggedInAsAdmin"
          variant="clear"
          data-test-id="change-password-button"
          @click="changePassword()"
        >
          {{ $t('changePasswordButton.label') }}
        </UIButton>
        <UIButton
          icon="mdi-logout"
          class="flex w-full justify-start normal-case"
          variant="danger-clear"
          data-test-id="logout-button"
          @click="logout()"
        >
          {{ $t('logoutButton.label') }}
        </UIButton>
      </div>
    </UIMenu>
  </div>
</template>
<script lang="ts" setup>
import { useIntercom } from '@manager/composables/use-intercom';
import { useUser } from '@manager/composables/use-user';
import { useAuthStore } from '@manager/store/auth-store';
import UIAvatar from 'shared/ui/registry/kinnovis/ui-avatar/UIAvatar.vue';
import UIButton from 'shared/ui/registry/kinnovis/ui-button/UIButton.vue';
import UIMenu from 'shared/ui/registry/kinnovis/ui-menu/UIMenu.vue';
import { computed } from 'vue';

import AppLanguageSwitcher from './AppLanguageSwitcher.vue';

withDefaults(defineProps<{ rail?: boolean }>(), { rail: false });

const { fullName, initials, email } = useUser();
const { shutdownIntercom } = useIntercom();
const authStore = useAuthStore();

const loggedInAsAdmin = computed(() => authStore.loggedInAsAdmin === true);

async function logout() {
  shutdownIntercom();

  await authStore.logout();
}

function changePassword() {
  authStore.changePassword();
}
</script>
